import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import {getPersianErrorCode} from '../../../global/helpers/ErrorCodes/ErrorCode';
import {ErrorResponse} from '../patchDirectLoanRequest/usePatchDirectLoanRequest';
import {postLoanValidationRequest} from './postLoanValidationRequest';

const usePostLoanValidationRequest = () => {
  const {mutate, isLoading} = useMutation({
    mutationFn: (loanRequestGuid: string) =>
      postLoanValidationRequest(loanRequestGuid),
  });

  return {mutate, isLoading};
};

export default usePostLoanValidationRequest;
